(function () {
  var STORE = 'bvCompare:v1';
  var tray = document.querySelector('[data-bvc-tray]');
  if (!tray) return;

  var MAX = parseInt(tray.dataset.max, 10) || 3;
  var slotsEl = tray.querySelector('[data-bvc-slots]');
  var countEl = tray.querySelector('[data-bvc-count]');
  var goEl = tray.querySelector('[data-bvc-go]');
  var toastEl = tray.querySelector('[data-bvc-toast]');
  var toastTimer, syncTimer;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify(items)); } catch (e) {}
  }
  var items = read();

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function indexOfKey(key) {
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return i;
    return -1;
  }
  function itemFrom(el) {
    var d = el.dataset;
    return { key: d.key, variantId: d.variantId, title: d.title, image: d.image, price: d.price, url: d.url };
  }
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  function syncChecks() {
    var full = items.length >= MAX;
    document.querySelectorAll('[data-bvc-check]').forEach(function (el) {
      var on = indexOfKey(el.dataset.key) > -1;
      var input = el.querySelector('.bvc-check__input');
      if (input) input.checked = on;
      el.classList.toggle('is-checked', on);
      el.classList.toggle('is-disabled', full && !on);
    });
  }

  function renderTray() {
    var n = items.length;
    tray.hidden = n === 0;
    document.documentElement.classList.toggle('bvc-tray-open', n > 0);
    countEl.textContent = n;

    var html = '';
    for (var i = 0; i < MAX; i++) {
      var it = items[i];
      if (it) {
        html += '<li class="bvc-slot">' +
          '<a class="bvc-slot__link" href="' + esc(it.url) + '">' +
            (it.image
              ? '<img class="bvc-slot__img" src="' + esc(it.image) + '" alt="" loading="lazy">'
              : '<span class="bvc-slot__img"></span>') +
            '<span class="bvc-slot__info">' +
              '<span class="bvc-slot__title">' + esc(it.title) + '</span>' +
              '<span class="bvc-slot__price">' + esc(it.price) + '</span>' +
            '</span>' +
          '</a>' +
          '<button type="button" class="bvc-slot__remove" data-bvc-remove="' + esc(it.key) + '" aria-label="Remove ' + esc(it.title) + '">&times;</button>' +
        '</li>';
      } else {
        html += '<li class="bvc-slot bvc-slot--empty" aria-hidden="true"></li>';
      }
    }
    slotsEl.innerHTML = html;

    var ready = n >= 2;
    goEl.classList.toggle('is-disabled', !ready);
    goEl.setAttribute('aria-disabled', String(!ready));
    goEl.href = ready
      ? tray.dataset.compareUrl + '?v=' + items.map(function (x) { return x.variantId; }).join(',')
      : '#';

    if (n > 0) {
      document.documentElement.style.setProperty('--bvc-tray-h', tray.offsetHeight + 'px');
    }
  }
    var lifted = [];
  function liftFloaters(on) {
  
    lifted.forEach(function (el) { el.style.translate = ''; });
    lifted = [];
    if (!on) return;
    var h = tray.offsetHeight;
    var vh = window.innerHeight;
    document.querySelectorAll('body > *, body > * > *').forEach(function (el) {
      if (el === tray || tray.contains(el) || el.contains(tray)) return;
      if (getComputedStyle(el).position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (!r.width || r.width > 200 || r.height > 200) return;
      if (r.bottom < vh - h) return;
      el.style.translate = '0 -' + h + 'px';
      lifted.push(el);
    });
  }

  function update() { renderTray(); syncChecks(); liftFloaters(items.length > 0); }
  
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('bvc-check__input')) return;
    var el = input.closest('[data-bvc-check]');
    if (!el) return;
    var i = indexOfKey(el.dataset.key);

    if (input.checked) {
      if (i === -1) {
        if (items.length >= MAX) {
          input.checked = false;
          toast('You can compare up to ' + MAX + ' products.');
          return;
        }
        items.push(itemFrom(el));
      }
    } else if (i > -1) {
      items.splice(i, 1);
    }
    save();
    update();
  });

  tray.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-bvc-remove]');
    if (rm) {
      var i = indexOfKey(rm.getAttribute('data-bvc-remove'));
      if (i > -1) items.splice(i, 1);
      save(); update();
      return;
    }
    if (e.target.closest('[data-bvc-clear]')) {
      items = [];
      save(); update();
      return;
    }
    var go = e.target.closest('[data-bvc-go]');
    if (go && go.classList.contains('is-disabled')) {
      e.preventDefault();
      toast('Select at least 2 products to compare.');
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === STORE) { items = read(); update(); }
  });
  window.addEventListener('pageshow', function () { items = read(); update(); });
  window.addEventListener('resize', function () {
    if (!tray.hidden) document.documentElement.style.setProperty('--bvc-tray-h', tray.offsetHeight + 'px');
    liftFloaters(items.length > 0);
  });

  new MutationObserver(function () {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncChecks(); liftFloaters(items.length > 0); }, 100);
  }).observe(document.body, { childList: true, subtree: true });

  update();
})();